import React from 'react';

const OrnamentCorner = ({ position = 'top-left', className = '' }) => {
  const getRotationClass = () => {
    switch (position) {
      case 'top-right':
        return 'rotate-180';
      case 'bottom-right':
        return '-rotate-90';
      case 'bottom-left':
        return '';
      default:
        return 'rotate-90';
    }
  };

  const getPositionClass = () => {
    switch (position) {
      case 'top-right':
        return 'top-0 right-0';
      case 'bottom-right':
        return 'bottom-0 right-0';
      case 'bottom-left':
        return 'bottom-0 left-0';
      default:
        return 'top-0 left-0';
    }
  };

  return (
    <img
      src="https://demo.lucky-roo.com/dahlia-v1.0/img/ornament-corner-primary.png"
      alt="Ornamento decorativo"
      className={`absolute w-24 md:w-32 ${getRotationClass()} ${getPositionClass()} ${className}`}
    />
  );
};

export default OrnamentCorner; 